import { useSwrFetch } from "./useSwrFetch";

interface UseShipperBookingStatsProps {
  shipperRoleId: number | null;
}

interface ShipperBookingStatsResponse {
  average_booking_duration_seconds: number | null;
}

interface UseShipperBookingStatsResult {
  avgBookingDurationSeconds: number | null;
  loading: boolean;
}

export function useShipperBookingStats(
  props: UseShipperBookingStatsProps,
): UseShipperBookingStatsResult {
  const { shipperRoleId } = props;
  const { data, loading } = useSwrFetch<ShipperBookingStatsResponse>({
    url:
      shipperRoleId !== null
        ? `/shippers/${shipperRoleId}/booking-stats`
        : null,
    errorMessage: "Failed to load shipper booking stats",
  });
  return {
    avgBookingDurationSeconds: data?.average_booking_duration_seconds ?? null,
    loading,
  };
}
